import { render, staticRenderFns } from "./template_sidebar.vue?vue&type=template&id=2c429810&scoped=true&"
import script from "./template_sidebar.vue?vue&type=script&lang=js&"
export * from "./template_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./template_sidebar.vue?vue&type=style&index=0&id=2c429810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c429810",
  null
  
)

export default component.exports